import { __assign } from 'tslib';
import useDefaultNavigationCTA from './useDefaultNavigationCTA.esm.js';

/**
 * Recursive function that loops through himself until finds pageProps
 * We need this function because the props we are receiving in `useNavigationCTA` are not what we are expecting
 */
var upToThePage = function (page) {
    var _a;
    // if found page props return those props
    if (page === null || page === void 0 ? void 0 : page.fields) {
        return page;
    }
    // if props has children, it means this props are not pageProps, so we pass children props thought this same function again
    if ((_a = page === null || page === void 0 ? void 0 : page.props) === null || _a === void 0 ? void 0 : _a.children) {
        return upToThePage(page.props.children);
    }
    // if doesn't have fields neither children, return null
    return null;
};
var useNavigationCTA = function (_a) {
    var page = _a.page;
    var defaultNavigationCTA = useDefaultNavigationCTA();
    var realPage = upToThePage(page);
    if (!realPage || !(realPage === null || realPage === void 0 ? void 0 : realPage.fields))
        return defaultNavigationCTA;
    var _b = realPage.fields, orderNowLinkOverride = _b.orderNowLinkOverride, hideOrderNowLink = _b.hideOrderNowLink;
    if (orderNowLinkOverride === null || orderNowLinkOverride === void 0 ? void 0 : orderNowLinkOverride.fields) {
        var _c = orderNowLinkOverride.fields, linkScheme = _c.linkScheme, text = _c.text;
        var _d = __assign({}, (linkScheme.fields || {})), _e = _d.url, url = _e === void 0 ? '' : _e, _f = _d.path, path = _f === void 0 ? '' : _f;
        return {
            hideOrderNowLink: hideOrderNowLink,
            navigationCta: text,
            navigationCtaPath: url || path,
        };
    }
    return __assign(__assign({}, defaultNavigationCTA), { hideOrderNowLink: hideOrderNowLink });
};

export { useNavigationCTA };
//# sourceMappingURL=useNavigationCTA.esm.js.map
